<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="turma-lotacao-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="searchLotacaoTurma" class="form-label">Pesquisar</label>
                                <input id="searchLotacaoTurma" v-model="search" @keyup="apertouEnter" type="text"
                                    class="form-control form-control-solid" placeholder="Pesquisar" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2" v-if="opcoes">
                                <label for="opcaoLotacaoTurma" class="form-label">Opcao</label>
                                <Multiselect id="opcaoLotacaoTurma" v-model="opcao_id" :options="opcoes_select"
                                    :searchable="true" @change="refreshTable" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="unidadeLotacaoTurma" class="form-label">Unidade</label>
                                <Multiselect id="unidadeLotacaoTurma" v-model="unidade_id" :filterResults="false"
                                    :minChars="3" :resolveOnLoad="true" :delay="500" :searchable="true"
                                    :options="async function(query) { return await buscarUnidade(query) }"
                                    noOptionsText="Nenhum item encontrado" @change="refreshTable" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2">
                                <label for="pelotaoLotacaoTurma" class="form-label">Pelotao</label>
                                <input id="pelotaoLotacaoTurma" v-model="pelotao" @keyup="apertouEnter" type="text"
                                    class="form-control form-control-solid" placeholder="Pelotao" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2 panel-actions">
                                <button type="button" class="btn btn-pmes-primary btn-sm" @click="exportarExcel" title="Exportar Excel">
                                    <i class="fas fa-file-excel"></i> Excel
                                </button>
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar
                                </button>
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false"
                            @tableatualizada="tableatualizada($event)">
                            <th>Id</th>
                            <th>Aluno</th>
                            <th>Numero</th>
                            <th>Pelotao</th>
                            <th>Unidade</th>
                            <th>Opcao</th>
                            <th style="min-width:130px" class="text-center" v-if="hasPermissaoAdmin">Acoes</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>

        <Editar :service="service" :modelo="modelo" :modal="modal_atualizar" v-if="hasPermissaoAdmin" :perfis="perfis"
            @lotacao-alterada="refreshTable" />
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { namespace } from 'vuex-class';
import CardRh from "@/components/cards/ManzaCard.vue";
import AlocacaoService from "@/service/v1/sigap/AlocacaoService";
import UnidadeService from "@/service/v1/sigap/UnidadeService";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from '@vueform/multiselect';
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Editar from "./_Editar.vue";
import $ from "jquery";

const authStore = namespace('auth');

@Options({
    name: "TurmaLotacoesIndex",
    components: { CardRh, KDataTable, Multiselect, Editar },
})
export default class TurmaLotacoesIndex extends Vue {
    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public token!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public modelo: any = null;
    public turmaId: any = null;
    public opcao_id: any = null;
    public opcoes: any = null;
    public unidade_id: any = null;
    public unidadeService = new UnidadeService();
    public modal_atualizar = 'modal_turma_lotacoes_update';
    public pelotao = '';
    public search = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
    }

    get opcoes_select() {
        if (this.opcoes) {
            return this.opcoes.map((item) => {
                return { value: item.id, label: item.nome.replaceAll('_', ' ') };
            });
        }
        return [];
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = '';
        this.opcao_id = null;
        this.unidade_id = null;
        this.pelotao = '';
        this.refreshTable();
    }

    public getOpcao() {
        this.processando = true;
        this.service.getOpcao()
            .then(response => {
                this.opcoes = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public exportarExcel() {
        const params: any = { token: this.token };
        if (this.turmaId) params.turmaId = this.turmaId;
        if (this.opcao_id) params.opcao = this.opcao_id;
        if (this.unidade_id) params.unidadeId = this.unidade_id;
        if (this.pelotao) params.pelotao = this.pelotao;
        const query = new URLSearchParams(params).toString();
        window.open(this.service.getApiUrl() + '/Excel?' + query);
    }

    public async buscarUnidade(query) {
        const response = await this.unidadeService.getAll( `search=${query}&status=1` );
        const dados = response.data ?? response;
        return dados.map((item) => {
            return { value: item.id, label: item.descricao };
        });
    }

    created() {
        this.turmaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new AlocacaoService();
        this.getOpcao();
        this.config.order = [[1, 'asc'],[5, 'asc']];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    opcao: this.opcao_id,
                    unidadeId: this.unidade_id,
                    pelotao: this.pelotao,
                    turmaId: this.turmaId,
                    search: this.search,
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: 'id', name: 'id' },
            { data: 'matricula.usuario.nome', name: 'matricula' },
            { data: 'matricula.numeroCurso', name: 'numerocurso' },
            { data: 'matricula.pelotao', name: 'pelotao' },
            { data: 'unidade.descricao', name: 'unidade' },
            { data: 'opcao', name: 'opcao', class: 'desktop' },
        ];

        this.config.columnDefs = [
            {
                targets: 5,
                render: (row) => {
                    return row?.nome ? row.nome.replaceAll('_', ' ') : '';
                }
            }
        ];

        if (this.hasPermissaoAdmin) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 6,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-warning btn-sm" btn-editar-lotacao ' + buttom + ' title="Editar" data-bs-toggle="modal" data-bs-target="#' + this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public pushColunaAcoes() {
        this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
    }

    public tableatualizada() {
        $('[btn-editar-lotacao]').click((btn) => {
            this.modelo = null;
            setTimeout(() => {
                this.modelo = $(btn.currentTarget).data();
            }, 10);
        });
    }
}
</script>

<style scoped>
.turma-lotacao-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

.registro-alteracao {
    text-align: right;
}

.card-header {
    min-height: 50px;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
